import SubLayout from "@/components/SubLayout";
import styles from "./index.module.scss";
// import { useSetup } from './logic';
import { CustomerIcon } from "@/components/CustomerIcon";
import { MessageIcon } from "@/components/MessageIcon";
import { Payments } from "@/constants";
import { payments } from "@/constants/payment/types";
import { AutoCenter, Button, List, Space } from "antd-mobile";
import classNames from "classnames";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSetup } from "./logic";

import { DialogLocal } from "@/components/Dialog";
import { useGlobalVerify } from "@/logic/verify";
import { useUserInfoStore } from "@/stores/userInfo";
import { useMount } from "ahooks";
import { Action } from "antd-mobile/es/components/swipe-action";
import { RenderItem, RenderPayment } from "./RenderItem";
import { Icon, IconName } from "@/components/Icon";
import { ContentTabs } from "./ContentTabs";
import { useCryptoPayments } from "@/stores/CryptoTradingStore";

export function PagePayment() {
  const store = useSetup();
  const navigate = useNavigate();
  const [verifySecurePassword, verifyGoogleAuthenticator] = useGlobalVerify();
  const [userinfo] = useUserInfoStore()((state) => [state.userInfo]);
  const [active, setActive] = useState<Payments>(Payments.BANK);
  const {hideAlipayWechat,hideProfessionAlipayWechat} = useCryptoPayments();

  const text = useMemo(() => {
    const item = payments.find((payment) => payment.value === active);
    return item?.label || item?.text || '';
  }, [active]);

  const subText = useMemo(() => {
    return payments.find((payment) => payment.value === active)?.subText;
  }, [active]);
  useEffect(() => {
    setActive(Payments.BANK)
  }, [store.isCryptoMerchant])

  const showPayments = useMemo(() => {
    console.log('hideProfessionAlipayWechat===',hideProfessionAlipayWechat);
    
    let showPayments = [...payments];
    if(store.isCryptoMerchant){
      showPayments = showPayments.filter(item => item.value !== Payments.DIGITAL_RMB);
    }
    if( hideAlipayWechat){
      return showPayments.filter((item) => item.value !== Payments.ALI && item.value !== Payments.WE_CHAT)
    }else if( hideProfessionAlipayWechat ){
      return showPayments.filter((item) => item.value !== Payments.ALI && item.value !== Payments.WE_CHAT)
    }else{
      return showPayments;
    }

  }, [payments, hideAlipayWechat,hideProfessionAlipayWechat, store.isCryptoMerchant])

  const filterPayments = useMemo(() => {
    const item = store.formatPayments[active];
    const payments: RenderPayment[] = item?.list || [];
    //  筛选普通  商家  超级商家收付
    return payments
    .filter(item => store.isCryptoMerchant  ? store.isProfession ? item.isProfession : item.isMerchant: (!item.isMerchant && !item.isProfession)  )
    .map((item) => ({
      ...item,
      type: active,
    }));
  }, [store.formatPayments, active, store.isCryptoMerchant,store.isProfession]);

  useMount(() => {
    store.fetchPaymentTypes();
  });

  const onAction = async (_: Action, item: RenderPayment) => {
    const isVerified = await verifyGoogleAuthenticator();
    if (!isVerified) return;
    const code = await verifySecurePassword();
    if (code) onSubmit(code as string, item.id);
  };

  const onSubmit = (value: string, id: number) => {
    store.unbind({ securePassword: value, id: id });
  };

  const onAdd = () => {
    if (!userinfo.isRealNameAuth) {
      return DialogLocal({
        cancelText: "取消",
        content: <AutoCenter>为保障您的资金安全，请实名认证！</AutoCenter>,
        onConfirm() {
          navigate(`/user_centify`);
        },
      });
    }

    if (!userinfo.secPasswordStatus) {
      return DialogLocal({
        cancelText: "取消",
        content: <AutoCenter>请设置资金密码！</AutoCenter>,
        onConfirm() {
          navigate(`/user_pay_psw`);
        },
      });
    }
    navigate(`/payment_add/${active}${store.isCryptoMerchant? `?m=${store.isProfession? 2 : 1}`: ''}`);
  };

  return (
    <SubLayout
      title={"收付款管理"}
      header={{
        extra: (
          <Space>
            <MessageIcon count={12} />
            <CustomerIcon />
          </Space>
        ),
      }}
      footer={
        <Button className={"common-submit-button"} onClick={() => {onAdd()}}>
          <div className={styles.submit_icon}></div> {subText}
        </Button>
      }
    >
      <div className={styles.page}>
        <section className={styles.header}>
          <div className={styles.bg}></div>
          <div className={styles.wrapper}></div>
          <div className={styles.text}>
            <div className={styles.logo}></div>
            <div>一款专业的C2C工具</div>
          </div>
        </section>
        <ContentTabs active={store.pageType}/>

        <section className={styles.tabs}>
          {showPayments.map((payment) => (
            <div
              className={classNames(
                styles.payment_tab,
                active === payment.value ? styles.active : ""
              )}
              key={payment.value}
              onClick={() => setActive(payment.value)}
            >
              {/* <div
                className={classNames(
                  styles.payment_icon,
                  styles[payment.icon]
                )}
              ></div> */}
              <div>
                <Icon
                  name={payment.icon as IconName}
                  key={payment.icon}
                  size={'0.3rem'}
                />
              </div>
              <div className={styles.payment_text}>{payment.text}</div>
            </div>
          ))}
        </section>
        <section className={styles.count}>
          我的{text}：{" "}
          <span className={styles.total}>
            共 {filterPayments.length || 0} 张
          </span>
        </section>
        <section className={styles.content}>
          {filterPayments.length ? (
            <List className={styles.list}>
              {filterPayments.map((item, index) => (
                <List.Item className={styles.listItem} key={item.id}>
                  <RenderItem item={item} index={index} onAction={onAction} />
                </List.Item>
              ))}
            </List>
          ) : (
            <div className={styles.empty}>
              <div className={styles.empty_bg}></div>
              您还未绑定任何{text}
            </div>
          )}
        </section>
      </div>
    </SubLayout>
  );
}
